import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import Icon from 'kingpin/atoms/Icon';
import Row from 'components/Common/Row';
import HighlightedText from './SearchResults/HighlightedText';
import GlobalSearchStyles from './styles';

const ICONS: { [type in GlobalSearch.ContentResultType]: Kingpin.Icon } = {
  dashboard: 'dashboard',
  report: 'find-in-page',
  scorecard: 'navigation-metrics',
  goal: 'navigation-goals',
  board: 'navigation-goals',
  workspace: 'workspace',
  app: 'workspace',
};

const ContentRow = ({
  result,
  searchText,
  onContentNavigate,
}: {
  result: GlobalSearch.ContentResult;
  searchText: string;
  onContentNavigate: (result: GlobalSearch.ContentResult) => void;
}) => {
  const onClick = useCallback(() => {
    onContentNavigate(result);
  }, [onContentNavigate, result]);

  return (
    <GlobalSearchStyles.GridRow data-testid={`content-result-${result.id}`}>
      <Row centerAlign style={{ gap: 8 }}>
        <Icon
          icon={ICONS[result.type]}
          width={16}
          height={16}
          color={'var(--color-text-muted)'}
        />
        <Link to={result.link} onClick={onClick}>
          <HighlightedText
            text={result.name}
            searchText={searchText}
            isLink={true}
          />
        </Link>
      </Row>
    </GlobalSearchStyles.GridRow>
  );
};

export default ContentRow;
